// @flow
export const SEARCH_SET_DATA = 'search/SET_DATA';

export function setSearchData(data) {
  return {
    type: SEARCH_SET_DATA,
    data,
  };
}



// WEBPACK FOOTER //
// ./actions/search.js